var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsCancelevent2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.04 16L27.41 5.63C27.7 5.34 27.7 4.88 27.41 4.59C27.13 4.31 26.65 4.31 26.37 4.59L16 14.96L5.63 4.59C5.34 4.3 4.88 4.3 4.59 4.59C4.3 4.88 4.3 5.34 4.59 5.63L14.96 16L4.59 26.37C4.3 26.66 4.3 27.12 4.59 27.41C4.87 27.69 5.35 27.69 5.63 27.41L16 17.04L26.37 27.41C26.65 27.69 27.13 27.69 27.41 27.41C27.7 27.12 27.7 26.66 27.41 26.37L17.04 16Z",
    fill: "#C41E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsCancelevent2023);
export default __webpack_public_path__ + "static/media/beemg-icons-cancelevent-2023.c9839768bdbd5d3017631e4636b8671e.svg";
export { ForwardRef as ReactComponent };